import { render, staticRenderFns } from "./checkbox-fill.vue?vue&type=template&id=5f08921a&"
import script from "./checkbox-fill.vue?vue&type=script&lang=js&"
export * from "./checkbox-fill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports